import { Container, Stack } from "@mantine/core";
import classes from "./DataColumn.module.css";

export function DataColumn({ children, maw, ...rest }) {
	return (
		<Container pos="relative" p={0} maw={maw} {...rest}>
			<Stack w={"100%"} p={0} className={classes.column}>
				{children}
			</Stack>
		</Container>
	);
}
